// extracted by mini-css-extract-plugin
export default {"cancelBtn":"CancelBtn_cancelBtn__yrDbi","cancelBtnText":"CancelBtn_cancelBtnText__vD++9"};